export function parsePageSearch(
  search: string,
): Record<string, string | readonly string[]> {
  const parameters = new URLSearchParams(search);
  const searchValues = new Map<string, string | string[]>();

  for (const [key, value] of parameters) {
    const previous = searchValues.get(key);

    if (previous === undefined) searchValues.set(key, value);
    else if (typeof previous === "string")
      searchValues.set(key, [previous, value]);
    else previous.push(value);
  }

  return Object.fromEntries(searchValues);
}

export function stringifyPageSearch(
  search: Readonly<Record<string, unknown>>,
): string {
  const parameters = new URLSearchParams();

  for (const [key, value] of Object.entries(search)) {
    if (value === undefined || value === null) continue;

    for (const item of Array.isArray(value) ? value : [value])
      parameters.append(key, String(item));
  }

  return parameters.size ? `?${parameters}` : "";
}
